module.exports = "void main()\n{\n\tgl_Position = vec4(position, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/passThrough.vs
// module id = 1
// module chunks = 0